export const PHOEBE_TEAM_USER_EMAIL = 'team@phoebe.work';
